import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

// Import styles
import { spaceX, flex, customMinResponsive, size, media, globalContentPadding } from 'components/styles';

export const FooterStyled = styled.footer`
	position: relative;
	border-top: 1px solid ${({ theme }) => theme.line};
	height: ${({ theme }) => theme.footer.height}rem;
	background-color: ${({ theme: { footer } }) => footer.bg};
	color: ${({ theme }) => theme.grayMedium};
	z-index: 999;
	${globalContentPadding()}

	${customMinResponsive(
		size.medium,
		css`
			height: 6.4rem;
		`
	)}
`;

const Content = styled.div`
	${flex({ fd: 'column' })}
	height: 100%;
	font-size: ${({ theme: { footer } }) => footer.fontSize}rem;
	margin: 0 auto;
	gap: 1rem;

	${customMinResponsive(
		size.medium,
		css`
			${flex()};
			gap: 0;
		`
	)}
`;
const Copyrights = styled.div`
	${flex()}
	color: ${({ theme }) => theme.white};
	font-size: ${({ theme: { footer } }) => footer.copyrights.fontSize}rem;
	opacity: 0.4;
	order: 3;
	padding: 1.5rem 0 1rem;

	${customMinResponsive(
		size.medium,
		css`
			order: 1;
			padding: 0;
		`
	)}
`;

export const FooterSide = styled.div`
	${flex()}
	flex: auto;
	order: 2;
	padding-top: 1rem;

	&:first-child {
		justify-content: flex-start;
	}
	&:last-child {
		justify-content: flex-end;
	}

	${customMinResponsive(
		size.medium,
		css`
			order: 1;
			padding: 0;
		`
	)}

	${customMinResponsive(
		1280,
		css`
			flex: 1;
		`
	)}
`;

export const FooterSideInfo = styled(FooterSide)`
	order: 1;
	${flex({ fd: 'column' })}

	${customMinResponsive(
		size.xsmall,
		css`
			${flex()}
		`
	)}
`;

FooterStyled.Content = Content;
FooterStyled.Copyrights = Copyrights;

export const Nav = styled.ul`
	list-style: none;
	display: flex;
	color: ${({ theme }) => theme.footer.link};
	margin-right: 1rem;
	align-items: center;
`;

export const Item = styled.li`
	color: ${({ theme }) => theme.white};
	& + &:before {
		content: ' | ';
		padding: 0 1.5rem;
	}
`;

export const linkStyle = css`
	&:link,
	&:visited {
		color: ${({ theme }) => theme.white};
		text-decoration: none;
		font-size: ${({ theme: { footer } }) => footer.links.fontSize}rem;
		transition: 0.2s ease-in-out;
	}

	&:hover,
	&:active {
		color: ${({ theme }) => theme.white};
	}
`;

export const RouterLink = styled(Link)`
	${linkStyle}
`;

export const LinkStyled = styled.a`
	${linkStyle}
`;

export const Social = styled.div`
	margin-top: 1rem;
	svg {
		height: 3.3rem;
	}

	a {
		display: inline-block;

		&:last-child {
			margin-left: 1.6rem;
		}
	}
	${media.min.xmin(css`
		margin-top: 0;
	`)}
`;

export const EmptySpace = styled.div`
	width: 27.5rem;
`;

export const PaymentWrapper = styled.div`
	width: 100%;
	${flex({ jc: 'space-between' })}
	margin-bottom: 1rem;

	${customMinResponsive(
		size.xsmall,
		css`
			margin-right: 3rem;
			margin-bottom: 0;
		`
	)}
	${media.min.xmin(css`
		width: auto;
		${flex()}
		${spaceX(20)}
	`)}
`;

export const PaymentIcon = styled.img`
	height: 2.4rem;
	width: auto;
`;
